import PropTypes from "prop-types";
import React from "react";
import Icon from "@mui/material/Icon";
import { QaRejections, QaRejectionsWithResponse } from "components/Homeowner/Appraisal";
import { MCollapsibleCard } from "components/Shared";

function CaseHeaderTitle({ count }) {
  const issuesIconType = count === 0 ? "thumb_up" : "thumb_down";
  const description =
    count === 1
      ? "There is 1 unresolved QA Issue"
      : "There are " + (!count || count === 0 ? "no" : count) + " unresolved QA Issues";

  return (
    <div style={{ color: 'var(--card-header-font-color)' }}>
      <Icon style={{ marginRight: "0.5em" }}>
        {issuesIconType}
      </Icon>
      {description}
    </div>
  );
}
CaseHeaderTitle.propTypes = { count: PropTypes.number };

const CaseRejections = (props) => {
  return (
    <MCollapsibleCard
      title={<CaseHeaderTitle count={props.unresolvedAppraiserRejectionCount} />}
      expanded={props.qaExpanded}
      onExpandedChange={(expanded) => props.expanderClicked(expanded)}
      wrapperClassName=""
    >
      <div>
        {
          props.viewOnly
            ? <QaRejections controlNumber={props.controlNumber} />
            : <QaRejectionsWithResponse controlNumber={props.controlNumber} />
        }
      </div>
    </MCollapsibleCard>
  );
};

CaseRejections.propTypes = {
  qaExpanded: PropTypes.bool, // Is the card expanded?
  expanderClicked: PropTypes.func, // Handle expansion of the card 
  controlNumber: PropTypes.number, // Control Number 
  unresolvedAppraiserRejectionCount: PropTypes.number, // Number of unresolved rejections
  viewOnly: PropTypes.bool, // List view only, or list with ability to respond to rejections
};

export default CaseRejections;

